const TermsModal = ({ setOpenTermsModal }) => {
  return (
    <>
      <div
        className={`fixed p-15 w-full max-w-[1280px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]`}
      >
        <div className="py-10 md:px-10 px-[7px] bg-card-color rounded-lg shadow-shadow-lg">
          <div className="my-10 lg:px-20 md:px-10 px-[7px] md:max-h-[80svh] max-h-[60svh] overflow-auto custom-scrollbar">
            <div className="text-[24px]/[30px] font-medium mb-2">
              წესები და პირობები
            </div>
            <div className="text-font-color-100 mb-6">
              შიდა გადაზიდვები საქართველოს ტერიტორიაზე (საფოსტო
              კორესპონდენცია/გზავნილები და ტვირთები)
            </div>
            <small className="text-font-color-100">
              მომსახურების პირობები და წესები
            </small>
            <ol
              className="list-decimal ps-6 leading-8 text-font-color-100"
              type="1"
            >
              <li>
                "შემსრულებელი" მხარეთა შეთანხმებით განსაზღვრული შესაბამისი
                საზღაურის მიღების პირობით და დამკვეთის უშუალო დავალებით
                ახორციელებს შიდა კორესპონდენციის/გზავნილების საფოსტო-საკურიერო
                და სატვირთო მომსახურეობას.
              </li>
              <li>
                ზოგიერთი ტვირთის გადაზიდვის სპეციფიკიდან გამომდინარე,
                შესაძლებელია, მხარეებს შორის, წინასწარ, გადაზიდვის პროცესის
                დაწყებამდე, მოხდეს ტარიფისა და გადაზიდვისათვის საჭირო გონივრული
                სატრანზიტო დროის შეთანხმება.
              </li>
              <li>
                დამკვეთი უზრუნველყოფს ,,შემსრულებელისთვის“ მომსახურების
                საფასურის ანაზღაურებას კონკრეტული პერიოდისათვის გამოცხადებული
                ტარიფებისა და საწვავის დანამატის მიხედვით, ან კონკრეტული ტვირთის
                გადაზიდვის სპეციფიკიდან გამომდინარე მხარეებს შორის წინასწარ
                შეთანხმებული ტარიფის მიხედვით, ,,შემსრულებლის“ მიერ წარდგენილი
                ინვოისის საფუძველზე. ამასთან გამოცხადებული ტარიფების ცვლილების
                შემთხვევაში, ,,შემსრულებელი“ ვალდებულია განათავსოს ცვლილების
                შესახებ ინფორმაცია შპს ,,ჯორჯიან ექსპრესი“-ს ვებგვერდზე
                (www.geoexpress.ge).
              </li>
              <li>
                კორესპონდენციის/გზავნილების საფოსტო-საკურიერო და სატვირთო
                მომსახურების სატრანზიტო დრო წარმოადგენს პრაქტიკიდან გამომდინარე
                საშუალო სატრანზიტო დროს რეგიონების/ზონების მიხედვით და არცერთ
                შემთხვევაში, დამატებითი შეთანხმების არსებობის გარდა, არ
                წარმოადგენს გადაზიდვისათვის დათქმულ სატრანზიტო ვადას, მრავალი
                ფაქტორიდან გამომდინარე. სატრანზიტო დროის დაუცველობის
                შემთხვევაში, თუ მხარეებს შორის არ არსებობს დამატებითი შეთანხმება
                სატრანზიტო დროსთან დაკავშირებით, ,,შემსრულებელს“ არ დაეკისრება
                პასუხისმგებლობა რაიმე პირდაპირ ან/და ირიბ ზარალზე ან/და ზიანზე.
              </li>
              <li>
                კორესპონდენციის/გზავნილების საფოსტო-საკურიერო და სატვირთო
                მომსახურების გაწევა უნდა განხორციელდეს სამუშაო დღეების სამუშაო
                დროის განმავლობაში, თუ მხარეებს შორის არ არსებობს, დამატებით,
                სხვა შეთანხმება კონკრეტული გადაზიდვის საჭიროებიდან გამომდინარე.
              </li>
              <li>
                კორესპონდენციის/გზავნილების საფოსტო-საკურიერო და სატვირთო
                მომსახურეობა რეგულირდება საქართველოს კანონმდებლობის შესაბამისად.
              </li>
              <li>
                კორესპონდენციის/გზავნილების საფოსტო-საკურიერო და სატვირთო
                მომსახურებისას, გამოიყენება მოცულობითი წონის ფორმულა: 1 კუბური
                მეტრი=167 კგ, რაც გამოითვლება შემდეგი წესით:
                სიგრძე*სიგანე*სიმაღლე (სმ)/6000. ამასთან გადასაზიდი
                გზავნილის/ტვირთის წონად ანგარიშსწორებისას ჩაითვლება ფაქტიური და
                მოცულობითი წონის უმეტესი მაჩვენებელი.
              </li>
              <li>
                კორესპონდენციის/გზავნილების საფოსტო-საკურიერო და სატვირთო
                მომსახურეობის პროცესში ,,შემსრულებელი“ უფლებამოსილია თავისი
                შეხედულებისამებრ გამოიყენოს, როგორც საკუთარი სატრანსპორტო
                საშუალებები, ასევე, მთლიანად ან ნაწილობრივ/ცალკეულ მონაკვეთებზე
                ტვირთის გადაზიდვა დაავალოს მესამე პირებსაც, თუ ეს აუცილებელია
                კონკრეტული გადაზიდვის საჭიროებიდან გამომდინარე.
              </li>
              <li>
                გადაზიდვის ორგანიზების უშუალო დაწყებამდე ,,შემსრულებელი“
                უფლებამოსილია შეამოწმოს ტვირთის შიგთავსი და მისი შესაბამისობა
                წარმოდგენილ დოკუმენტაციასთან.
              </li>
              <li>
                იმ შემთხვევაში, თუ გზავნილის ზღვრული ღირებულება აღემატება 300
                ლარს, დამკვეთი ვალდებულია, ამის შესახებ, შეატყობინოს
                ,,შემსრულებელს“ წინასწარ, გადაზიდვის დაწყებამდე და მიიღოს
                კონსულტაცია ასეთი გზავნილის გადაზიდვასთან დაკავშირებით. 11.
                დამკვეთი ვალდებულია ,,შემსრულებელს“ სრულად და ამომწურავად
                მიაწოდოს გზავნილის თანმხლები ის სავალდებულო და აუცილებელი
                დოკუმენტაცია (ტვირთის ღირებულების დამადასტურებელი დოკუმენტი
                ან/და აღნიშნოს ტვირთის ღირებულება ელექტრონულად დატვირთულ
                ზედნადებში) და მონაცემები, რომელმაც შეიძლება გავლენა იქონიოს
                კონკრეტული ტრანსპორტირების ღირებულებაზე. ასეთ დოკუმენტაციას და
                მონაცემებს განეკუთვნება:
              </li>
              <li>
                1. სასაქონლო ზედნადები (ელექტრონული ფორმით ატვირთვა), საჭიროების
                შემთხვევაში, გადაზიდვასთან დაკავშირებული სხვა დოკუმენტაცია.
                <br />
                2. გადაზიდვის საწყისი, საბოლოო დანიშნულების პუნქტი ან პუნქტები,
                ასევე, მიმღების/გამგზავნის სრული საკონტაქტო ინფორმაცია, რომელიც
                უნდა მოიცავდეს ზუსტ მისამართს და საკონტაქტო ტელეფონის ნომერს.
                <br />
                3. გზავნილის ზუსტი წონა და გაბარიტები. ამასთან ,,შემსრულებელი“
                ახორციელებს ამ ინფორმაციის გადამოწმებას და საჭიროების
                შემთხვევაში, გამგზავნთან/დამკვეთთან შეთანხმებით აზუსტებს მას.
              </li>
              <li>
                დამკვეთი ვალდებულია ,,შემსრულებელს“ გადასცეს სათანადოდ შეფუთული
                ტვირთი, ან შესაბამის შემთხვევაში დაუკვეთოს შეფუთვა
                ,,შემსრულებელს“ სასაწყობო და სატერმინალო (საქართველოს
                ტერიტორიაზე) მომსახურების პირობების და წესების თანახმად,
                ვინაიდან ,,შემსრულებელი“ პასუხს არ აგებს დამკვეთის მიერ ტვირთის
                არასათანადოდ შეფუთვით გამოწვეულ დაზიანებაზე.
              </li>
              <li>
                დამკვეთი ვალდებულია უზრუნველყოს გზავნილისა და თანმხლები
                დოკუმენტაციის ჯეროვნად მზაობა, რაც გულისხმობს სათანადო შეფუთვასა
                და კანონით გათვალისწინებულ შემთხვევაში, სასაქონლო ზედნადების
                ელექტრონულად ატვირთვას. დამკვეთი, ასევე, ვალდებულია გზავნილი და
                თანხმლები დოკუმენტაცია ჯეროვნად ჰქონდეს გამზადებული
                "შემსრულებლი" სატრანსპორტო საშუალების ადგილზე მისვლის
                მომენტისათვის.
              </li>
              <li>
                "შემსრულებელ" ვალდებულია, დამკვეთის მიერ მიწოდებული ინფორმაციის
                საფუძველზე, მოახდინოს სატრანსპორტო დოკუმენტაციის სწორად
                გაფორმება. ხოლო თუ დამკვეთი, მისთვის ჩატვირთული პროგრამის
                მეშვეობით, თავად ახორციელებს სატრანსპორტო დოკუმენტაციის
                გაფორმებას, დამკვეთი თვითონ არის პასუხისმგებელი ასეთი
                დოკუმენტაციის სისწორეზე.
              </li>
              <li>
                "შემსრულებელ" ვალდებულია უზრუნველყოს დამკვეთისგან მიღებული
                გზავნილის შეთანხმებულ დანიშნულების ადგილზე ტრანსპორტირება და
                მისი გადაცემა მიმღებისათვის ან მისამართზე დამხდური პირისთვის
                სრულად და დაუზიანებლად.
              </li>
              <li>
                "შემსრულებელი" ვალდებულია, მოთხოვნის შემთხვევაში, დამკვეთს
                მიაწოდოს ინფორმაცია ტვირთის ტრანსპორტირებასთან დაკავშირებული
                სამუშაოს შესრულების შესახებ, ასევე, ინფორმაცია დროის გარკვეული
                მომენტებისათვის ტვირთის ადგილსამყოფელის შესახებ, მათ შორის,
                არსებობის შემთხვევაში, ინფორმაცია იმ გარემოებების შესახებ, რამაც
                შესაძლოა შეაფერხოს, ან დროებით შეაჩეროს ტვირთის ტრანსპორტირების
                განხორციელება.
              </li>
              <li>
                გზავნილის ჩაბარება დანიშნულების ადგილზე უნდა განხორციელდეს
                დამკვეთის მიერ მითითებულ მისამართზე, ამასთან, ,,შემსრულებელი“ არ
                იღებს ვალდებულებას, რომ გზავნილი ჩააბაროს უშუალოდ საკონტაქტო
                პირს, თუ მხარეთა შორის ამაზე არ არსებობს შეთანხმება და არ არის
                გადახდილი ტარიფზე დანამატი (განსაკუთრებული პირობა ჩაბარება
                საკონტაქტო პირზე, პირადი ნომრის ან/და თანამდებობის მითითებით).
                დამკვეთისათვის გზავნილის ჩაბარების შესახებ დეტალების მიწოდება
                განიხილება ცალკე მომსახურებად, შესაბამისად, მასზე დაწესებულია
                ცალკე ტარიფი.
              </li>
              <li>
                იმ შემთხვევებში, თუ შეუძლებელია საბოლოო დანიშნულების ადგილზე
                მომსახურების განხორციელება დამკვეთისგან გამომდინარე მიზეზით
                (არასწორი/არასრული მისამართის გამო, მიმღების სხვა მისამართზე
                გადასვლის გამო) ახალ მისამართზე გზავნილის გაგზავნა
                განხორციელდება დამატებითი საფასურის გადახდის პირობით.
              </li>
              <li>
                30 კგ-მდე გზავნილის ჩაბარების მცდელობას მიმღებისთვის
                ,,შემსრულებელი“ განახორციელებს ორჯერ, მხოლოდ პირველი ზონის
                ქალაქებში,მათ შორის მეორედ მომდევნო სამუშაო დღეს. ორივე ჯერზე
                ჩაბარების შეუძლებლობის შემთხვევაში (მიმღების მისამართზე
                ნებისმიერი მიზეზით არ ყოფნის შემთხვევაში), გზავნილი განთავსებულ
                იქნება მოკითხვამდე რეჟიმით მიმღები ქალაქის ან და მიმღებ ქალაქთან
                უახლოეს "შემსრულებელის" ოფისში, ამავდროულად, "შემსრულებელი"
                მიმღების მისამართზე/კართან დატოვებს შეტყობინებას "შემსრულებლი"
                უახლოესი ოფისის მისამართისა და სამუშაო საათების შესახებ; 30 კგ-ს
                ზევით გზავნილის შემთხვევაში კი პირველივე უშედეგო მცდელობის
                შემდეგ, გზავნილი განთავსებული იქნება "შემსრულებლის" უახლოეს
                საწყობში, საიდანაც გზავნილის/ტვირთის გატანა შესაძლებელი იქნება
                მიმღების მიერ; ან დამკვეთისგან დამატებითი საფასურის გადახდის
                პირობით, "შემსრულებელი" კვლავ განახორციელებს გზავნილის ჩაბარების
                მცდელობას.
              </li>
              <li>
                იმ შემთხვევაში, თუ მიმღები უარს განაცხადებს გზავნილის მიღებაზე
                ან მომსახურების საფასურის გადახდაზე (თუ საფასურის გადახდა
                მიმღების ვალდებულებაა), მაშინ, საფასურს აანაზღაურებს დამკვეთი.
              </li>
              <li>
                იმ შემთხვევაში, თუ დამკვეთის მიერ ტვირთის თანმხლებ
                დოკუმენტაციაში მითითებულ მე-11 პუნქტში ინფორმაცია ტვირთთან
                შეუსაბამო აღმოჩნდება, რის გამოც მისი გადაზიდვის, შენახვის ან/და
                დამუშავებისას ფაქტობრივად წარმოიშვება დამატებითი დანახარჯები -
                დამკვეთი ვალდებულია "შემსრულებელს" სრულად და ჯეროვნად
                აუნაზღაუროს ამით მიყენებული ყველა შესაძლო ზიანი, დამატებითი
                ხარჯი, თუ ჯარიმა, როგორიც არის: ტვირთის იძულებითი შენახვა,
                ტვირთის შესაბამის ტემპერატურულ რეჟიმში იძულებითი შენახვა,
                მაკონტროლებელი ორგანიზაციების მიერ დაკისრებული სანქციები ან/და
                შესაბამის შემთხვევაში ტვირთის განადგურებისა და სხვა მსგავსი
                ხარჯები. სასაწყობო და სატერმინალო (საქართველოს ტერიტორიაზე)
                მომსახურების პირობები და წესები
              </li>
            </ol>
            <ol
              className="list-decimal ps-6 leading-8 text-font-color-100"
              type="1"
            >
              <li>
                "შემსრულებელი" მხარეთა შეთანხმებით განსაზღვრული შესაბამისი
                საზღაურის მიღების პირობით და დამკვეთის უშუალო დავალებით,
                ახორციელებს საქართველოს ტერიტორიაზე სასაწყობო მომსახურეობას.
              </li>
              <li>
                სასაწყობო მომსახურების სრული სპექტრიდან, დამკვეთს,
                საჭიროებისამებრ, შეუძლია გამოიყენოს ერთი ან რამდენიმე
                მომსახურეობა:
                <br />
                1. სტანდარტული სასაწყობო მომსახურება:
                <br />
                2. შენახვა დახურული ტიპის საწყობში სხვადასხვა ტემპერატურულ
                რეჟიმში
                <br />
                3. შენახვა ღია ტიპის საწყობში
                <br />
                4. შენახვა სტელაჟებზე, მიწის დონეზე, პაქბინებში
                <br />
                5. სატრანსპორტო საშუალების დაცლა/დატვირთვა, როგორც მექანიკურად,
                ასევე, ხელით
                <br />
                6. ქროსდოქინგი
                <br />
                7. მიღება სახეობების/დასახელების მიხედვით
                <br />
                8. ზედნადების შექმნა/რეგისტრაციით, მარკირება
                <br />
                9. დახარისხება
                <br />
                10. შეკვეთის აწყობა, კომპლექტაცია
                <br />
                11. აწონვა, გადაწონვა
                <br />
                12. პალეტიზირება, შეფუთვა, გადაფუთვა
                <br />
                13. საწყობიდან გაცემა დამკვეთზე
                <br />
                14. ინვენტარიზაცია, მარაგების მართვა და შესაბამისი დოკუმენტაციის
                გაფორმება
                <br />
                15. მონაცემთა ელექტრონული გადაცემა
                <br />
                16. უტილიზაცია, განადგურება
              </li>
              <li>
                დამკვეთი უზრუნველყოფს "შემსრულებლისთვის" მომსახურების საფასურის
                ანაზღაურებას, მხარეებს შორის შეთანხმებული ტარიფის მიხედვით,
                "შემსრულებლის" მიერ წარდგენილი ინვოისის საფუძველზე,
                ყოველთვიურად.
              </li>
              <li>
                ტარიფის დაანგარიშება ხდება ყოველი ცალკეული შემთხვევისათვის,
                კონკრეტული მომსახურების მიხედვით, ტვირთის ზომის, წონის, საჭირო
                შეფუთვის ტიპის, დასაწყობების ხანგრძლივობის, დასაწყობების
                რეჟიმისა და დასაწყობების საჭირო ტემპერატურის მიხედვით
              </li>
              <li>
                სასაწყობო მომსახურების გაწევა უნდა განხორციელდეს სამუშაო დღეების
                სამუშაო დროის განმავლობაში, თუ მხარეებს შორის არ არსებობს,
                დამატებით, სხვა შეთანხმება, სასაწყობო ოპერაციიდან საჭიროებიდან
                გამომდინარე.
              </li>
              <li>
                სასაწყობო მომსახურეობა რეგულირდება საქართველოს კანონმდებლობის
                შესაბამისად.
              </li>
              <li>
                სასაწყობო მომსახურეობის გაწევისას, "შემსრულებელი" უფლებამოსილია
                განახორციელოს ოპერაციები, როგორც საკუთარ სასაწყობო ფართში,
                ასევე, იჯარით აიღოს სასაწყობო ფართი მესამე პირებისაგან.
              </li>
              <li>
                საწყობში ნებისმიერი სასაწყობო ოპერაციის ორგანიზების მიზნით,
                ტვირთის მიღება ხდება დამკვეთისა და "შემსრულებლის"
                წარმომადგენლების მიერ, მითვლის, რაოდენობისა და ხარისხის
                შემოწმების შემდგომ, მიღება-ჩაბარების აქტის გაფორმების
                საფუძველზე.
              </li>
              <li>
                დამკვეთი ვალდებულია მიაწოდოს "შემსრულებელი"-ს მე-4 პუნქტში
                მითითებული ინფორმაცია დეტალურად და სწორად.
              </li>
              <li>
                დამკვეთი ვალდებულია შენახვის მომსახურების გამოყენების
                შემთხვევაში, მიაწოდოს "შემსრულებელს" დეტალური ინფორმაცია
                შესანახი ან/და დასამუშავებელი ტვირთის შენახვისათვის საჭირო
                რეჟიმისა და ტემპერატურის შესახებ.
              </li>
              <li>
                დამკვეთი ვალდებულია შენახვის სატრანსპორტო საშუალების
                დაცლა/დატვირთვის გამოყენების შემთხვევაში, მიაწოდოს
                "შემსრულებელს" ინფორმაცია სატრანსპორტო საშუალების საწყობში
                მოსვლის დროისა და დაცლა/დატვირთვის სასურველი ტიპის შესახებ.
              </li>
              <li>
                დამკვეთი ვალდებულია დახარისხების, კომპლექტაციის და შეკვეთის
                აწყობის მომსახურების გამოყენების შემთხვევაში, მიაწოდოს
                "შემსრულებელს" დაზუსტებული ინფორმაცია სახეობების/დასახელებებისა
                და მათი რაოდენობის მიხედვით.
              </li>
              <li>
                დამკვეთი ვალდებულია პალეტიზირების, შეფუთვის, გადაფუთვის
                მომსახურების გამოყენების შემთხვევაში, მიაწოდოს "შემსრულებელს"
                დაზუსტებული ინფორმაცია პალეტის ზომის და პალეტზე განსათავსებელი
                პროდუქტის რაოდენობისა და წონის, ისევე, როგორც სასურველი შეფუთვის
                ტიპის შესახებ.
              </li>
              <li>
                დამკვეთი ვალდებულია საწყობიდან გაცემის მომსახურების გამოყენების
                შემთხვევაში, მიაწოდოს "შემსრულებელს" დაზუსტებული ინფორმაცია თუ
                რომელი სახეობა/დასახელება რა რაოდენობით, როდის და ვისზე უნდა
                გაიცეს.
              </li>
              <li>
                დამკვეთი ვალდებულია ატვირთოს სწორი ელექტრონული ზედნადები იმ
                შემთხვევაში, თუ საწყობში არსებული ტვირთის ნაწილის ან სრულად
                გადაზიდვას საქართველოს ტერიტორიაზე უკვეთავს "შემსრულებელ".
              </li>
              <li>
                დამკვეთი ვალდებულია განადგურება, უტილიზაციის მომსახურების
                გამოყენების შემთხვევაში, მიაწოდოს "შემსრულებელს" ტვირთის
                სპეციფიკიდან გამომდინარე მისი განადგურებისათვის საჭირო დეტალური
                ინფორმაცია.
              </li>
              <li>
                "შემსრულებელი" ვალდებულია უზრუნველყოს სასაწყობო მომსახურეობები
                სუფთა და დაცულ სასაწყობო ფართში.
              </li>
              <li>
                "შემსრულებელი" ვალდებულია უზრუნველყოფილი ჰქონდეს სასაწყობო ფართი
                ცეცხლმაქრებით, სახანძრო სიგნალიზაციით, სამეთვალყურეო კამერებითა
                და უსაფრთხოების სისტემით.
              </li>
              <li>
                "შემსრულებელი" ვალდებულია უზრუნველყოს მე-2 პუნქტში მითითებული
                მომსახურეობები, დამკვეთის მიერ მოწოდებული დავალების თანახმად,
                სრულად, უნაკლოდ და შეთანხმებულ ვადებში შესრულება.
              </li>
              <li>
                "შემსრულებელი" ვალდებულია, მოთხოვნის შემთხვევაში, დამკვეთს
                მიაწოდოს ინფორმაცია სასაწყობო ოპერაციებთან დაკავშირებული
                სამუშაოს შესრულების შესახებ, ასევე, ინფორმაცია დროის გარკვეული
                მომენტებისათვის ინვენტარიზაციისა და საწყობში არსებული ნაშთების
                შესახებ სახეობების/დასახელებების მიხედვით.
              </li>
              <li>
                იმ შემთხვევაში, თუ საწყობში განთავსებული ტვირთის
                დისტრიბუცია/მიწოდება საქართველოს ტერიტორიაზე ევალება
                "შემსრულებელს", ასეთ მომსახურეობაზე გავრცელდება "შიდა
                გადაზიდვები საქართველოს ტერიტორიაზე (საფოსტო
                კორესპონდენცია/გზავნილები და ტვირთები)" მომსახურების პირობები და
                წესები.
              </li>
              <li>
                იმ შემთხვევაში, თუ დამკვეთის მიერ მოწოდებული ინფორმაცია მე-4
                პუნქტში ტვირთთან შეუსაბამო აღმოჩნდება, რის გამოც, შენახვისას
                ან/და დამუშავებისას, ფაქტობრივად, წარმოიშვება დამატებითი
                დანახარჯები, დამკვეთი ვალდებულია "შემსრულებელს" სრულად და
                ჯეროვნად აუნაზღაუროს ამით მიყენებული ყველა შესაძლო ზიანი,
                დამატებითი ხარჯი, თუ ჯარიმა, როგორიც არის: რემარკირება,
                ზედნადების შექმნა/რეგისტრაცია დახარისხების, კომპლექტაციის,
                დაპალეტების, შეფუთვისა და გადაფუთვის, ტვირთის არასწორ
                ტემპერატურულ რეჟიმში შენახვისგან გამომდინარე წარმოშობილი
                შედეგების აღმოფხვრისა ან/და განადგურების ხარჯები, ან/და
                მაკონტროლებელი ორგანიზაციების მიერ დაკისრებული სანქციები.
                პრეტენზიებისა და მიმართვის წარდგენის ვადები
              </li>
            </ol>
            <ol
              className="list-decimal ps-6 leading-8 text-font-color-100"
              type="1"
            >
              <li>
                ტვირთის/გზავნილის მიღებისას მისი გარეგნულად შესამჩნევი
                დაზიანებისა ან/და დანაკლისის შემთხვევაში, დამკვეთი ვალდებულია
                იმავე დღეს აცნობოს ,,შემსრულებელს“ აღნიშნულის თაობაზე, მოითხოვოს
                "შემსრულებლის" წარმომადგენლის დასწრება დათვალიერებისას,
                უზრუნველყოს შესაბამისი აქტის შედგენა მხარეთა წარმომადგენლებისა
                და დამოუკიდებელი, კომპეტენტური ექსპერტის მონაწილეობით.
              </li>
              <li>
                ტვირთის/გზავნილის მიღებისას გარეგნულად შეუმჩნეველი დაზიანებისას,
                დამკვეთი ვალდებულია მიმართოს "შემსრულებელს" შესაბამისი
                წერილობითი პრეტენზიით ტვირთის/გზავნილის მიღებიდან არაუგვიანეს 7
                (შვიდი) დღისა. აღნიშნული ვადის გასვლის შემდეგ დამკვეთის
                პრეტენზია "შემსრულებლის" მიმართ არ დაიშვება. ფორს-მაჟორული
                გარემოებები
              </li>
            </ol>
            <ol
              className="list-decimal ps-6 leading-8 text-font-color-100"
              type="1"
            >
              <li>
                იმ შემთხვევაში, თუ ხელშეკრულების პირობების შეუსრულებლობა ან/და
                შესრულების გაჭიანურება გამოწვეულია დაუძლეველი ძალის ზემოქმედების
                შედეგად (ფორსმაჟორი - სტიქიური უბედურება, პანდემია, ომი,
                სამხედრო მანევრები, დივერსია, ხანძარი, გაფიცვები, ბლოკადა,
                ემბარგო, საქართველოს ან მიმღები ქვეყნის ტერიტორიაზე, ისევე,
                როგორც ტვირთის მოძრაობის მარშრუტზე, ტვირთის გადაზიდვასთან
                დაკავშირებით ხელისუფლებისა და მმართველობის ორგანოების მიერ
                გამოცემული აქტები, რამაც შეიძლება შეაფერხოს ან/და შეუძლებელი
                გახადოს მხარეთათვის ამ ხელშეკრულებით მათ მიერ ნაკისრი
                ვალდებულებებისა და დადგენილი პირობების შესრულება და სხვა),
                მხარეები გააგრძელებენ ხელშეკრულების პირობების ჯეროვნად
                შესრულებას ამგვარი გარემოებების დასრულებისთანავე, ხოლო
                ფორსმაჟორით გამოწვეული ვალდებულებების შეუსრულებლობა არ ჩაითვლება
                ხელშეკრულების დარღვევად.
              </li>
              <li>
                თუ ამგვარი გარემოებები გრძელდება და შეუძლებელს ხდის მხარეთათვის
                ხელშეკრულებით ნაკისრი ვალდებულებების ჯეროვნად შესრულებას,
                მხარეები უფლებამოსილი არიან შესაბამისი წერილობითი შეთანხმებით
                მიაღწიონ მათთვის მისაღებ ნებისმიერ გადაწყვეტილებას.
              </li>
              <li>
                იმ მხარემ, რომლისთვისაც შეუძლებელი გახდა ხელშეკრულებით ნაკისრი
                ვალდებულებების შესრულება ფორსმაჟორული გარემოებების გამო,
                დაუყოვნებლივ უნდა შეატყობინოს ამის შესახებ მეორე მხარეს,
                პირველივე შესაძლებლობისთანავე. დავათა გადაჭრის წესი
              </li>
            </ol>
            <ol
              className="list-decimal ps-6 leading-8 text-font-color-100"
              type="1"
            >
              <li>
                ამ ხელშეკრულებით ნაკისრი ვალდებულების შესრულებიდან წარმოშობილი
                ნებისმიერი დავა ან/და უთანხმოება უნდა გადაწყდეს მხარეთა შორის
                მოლაპარაკებების გზით, წინააღმდეგ შემთხვევაში დავას განიხილავს
                სასამართლო.
              </li>
              <li>
                მხარეთა შორის ამ ხელშეკრულების საფუძველზე წარმოშობილი
                სამართლებრივი ურთიერთობები მოწესრიგდება მომსახურების
                მარეგულირებელი საქართველოს მოქმედი კანონმდებლობით.
              </li>
            </ol>
          </div>
          <div className="flex items-stretch gap-5">
            <button onClick={setOpenTermsModal} className="btn btn-secondary">
              დახურვა
            </button>
          </div>
        </div>
      </div>
      <div
        onClick={setOpenTermsModal}
        className={`contents-[] fixed z-[5] w-full h-full left-0 top-0 bg-black-50 backdrop-blur-[2px]`}
      ></div>
    </>
  );
};

export default TermsModal;
